import React, { useState } from "react";
import Sidebar from './SideBar';
import Top from './Top';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


export default function Layout({ setIsLoggedIn }) {
      const [selectedNotice, setSelectedNotice] = useState(null);


    return (
        <div className="nk-app-root">
            <div className="nk-main ">
                <Sidebar />
                <div className="nk-wrap ">
    <Top
      selectedNotice={selectedNotice}
      setSelectedNotice={setSelectedNotice}
      setIsLoggedIn={setIsLoggedIn} 
    />
                      <Outlet context={{ selectedNotice, setSelectedNotice, setIsLoggedIn  }} />
                    <Footer selectedNotice={selectedNotice}/>
                </div>
            </div>
        </div>
    );
}
